import styled from 'styled-components';

export const WrapperTickets = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  
  .section-form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, .5fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }
  .section-one-form {
    grid-area: 1 / 1 / 1 / 2;
  }
  .section-two-form {
    grid-area: 1 / 2 / 2 / 2;
    .section-button {
      display: flex;
      justify-content: end;
      align-items: flex-end;
      margin-right: 50px;
      margin-top: 20px;
    }
  }
`;

export const Input = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 30px 0px 0px;
`;

export const InputDate = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 30px 0px 0px;
  width: 50%;
`;
